import LoginSocialBase from './Base.jsx';
import loadFbSdk from 'load-fb-sdk';

class LoginSocialFacebook extends LoginSocialBase {

  constructor(...args) {
    super('facebook', ...args);

    this.onSDKLoad = this.onSDKLoad.bind(this);

  }

  onSDKLoad(err, api) {
    if (err) {
      return console.error(err);
    }

    this.api = api;

    if(!this.$button.length) {
      return;
    }

    this.enableButton();

    this.$button.on('click', (e) => {
      e.preventDefault();
      this.loginWithSocial();
    });

  }

  init() {
    // eslint-disable-next-line
    const appId = lrg_login.fbAppId

    window.__LOAD_FB_SDK = {
      appId: appId,
      version: 'v8.0',
    };

    loadFbSdk(this.onSDKLoad)
  }

  getUserId() {
    return new Promise((resolve) => {
      const statusChangeCallbackFactory = (notLoggedInCallback) => ({ status, authResponse }) => {
        switch (status) {
          case 'connected':
            resolve(authResponse.userID);
          break;
          default:
            notLoggedInCallback ? notLoggedInCallback() : null;
            break;
        }
      };

      this.api.getLoginStatus(statusChangeCallbackFactory(() => {
        this.api.login(statusChangeCallbackFactory());
      }));
    });
  }
}

export default LoginSocialFacebook;
